import { checkEnvironment } from '@saviynt/common';

const getCancelApiUrl = (requestKey) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/requests/${requestKey}`;
};

export default getCancelApiUrl;
